import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../../../components/Loader'
import s from './WhyHostBlock1.css';
import WhyHostFormBlock1 from '../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock1'
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import { withQuery } from '../../../../hoc/withGraphql';

class WhyHostBlock1 extends React.Component {

    static defaultProps = {
        data: {
            loading: false
        }
    };

    render() {
        const { data: { loading, getWhyHostPage } } = this.props
        let settingsCollection = {}
        if(loading){
            return <Loader type={"text"} />;
        } else {
            getWhyHostPage.map((item, key) => {
                settingsCollection[item.name] = item.value
            });
            return <WhyHostFormBlock1 initialValues={settingsCollection} />
        }
    }
}

export default compose(
    withStyles(s),
    withQuery(getWhyHostPageSettings, {
        options: {
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
)(WhyHostBlock1);